module.exports = __webpack_public_path__ + "static/img/2.e0a5021.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/eng/2.png
// module id = QvEY
// module chunks = 0